"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SourceListAudioFileItemBody = require("./SourceListAudioFileItemBody.styled");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var SourceListAudioFileItemBody = function SourceListAudioFileItemBody(_ref) {
  var value = _ref.value;
  var audioRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
    volume = _useState2[0];
  (0, _react.useEffect)(function () {
    audioRef.current.volume = volume / 100;
    audioRef.current.currentTime = 0;
  });
  return /*#__PURE__*/_react["default"].createElement(_SourceListAudioFileItemBody.AudioPlayer, null, /*#__PURE__*/_react["default"].createElement("audio", {
    ref: audioRef,
    src: value
  }, "Your browser does not support the audio file"));
};
SourceListAudioFileItemBody.propTypes = {
  value: _propTypes["default"].string,
  hidden: _propTypes["default"].bool,
  live: _propTypes["default"].bool
};
var _default = exports["default"] = SourceListAudioFileItemBody;